module.exports = __webpack_public_path__ + "img/compact&rtl.675e88dd.jpg";